import {GateElement, GateStyle} from "../elements/GateElement";
import {POPUP_GATE_TRANSITION_TIME} from "../../Constants";

const BannerGateStyle = {
    gate: {
        ...GateStyle.gate,
        background: "#FFF",
        padding: "10px",
        boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.1)",
        bottom: 0,
        boxSizing: "border-box",
        left: 0,
        width: "100%",
        position: "fixed",
        zIndex: 9999997, // It has to be under the scrim and widget.
    },
    visibleGate: {
        opacity: 1,
        pointerEvents: "initial",
    },
    invisibleGate: {
        opacity: 0,
        pointerEvents: "none",
    },
};

export class BannerGate extends GateElement {
    styleSheet = BannerGateStyle;

    refreshStyle() {
        super.refreshStyle();
        this.setStyle(this.options.customStyle ?? {});

        if (this.panel.height) {
            this.setStyle(this.styleSheet.visibleGate);
        } else {
            this.setStyle(this.styleSheet.invisibleGate);
        }
    }
}
